module.exports = __webpack_public_path__ + "static/media/m4.a00819ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/map-cluster-icons/m4.png
// module id = 509
// module chunks = 0